<div class="pending-evaluation-popup">
    <div class="pending-evaluation-info">
        <img src="../../../../../assets/icons/clock-1.svg" alt="" class="icon-size">
        <div class="pending-evaluation-info-content">
            <p class="pending-evaluation-info-content__title">
                Estamos validando tu perfil
            </p>
            <p class="pending-evaluation-info-content__text">
                El proceso puede tomar hasta 12 horas. Te avisaremos por correo apenas la validación esté lista.
            </p>
        </div>
    </div>
    <div class="button-actions">
        <lib-ui-button
            variant="filled"
            size="l"
            [fullWidth]="true"
            (click)="close()"
            label="Explorar el portal"
        ></lib-ui-button>
    </div>
</div>